import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'tireType',
  title: 'Tire Types',
  type: 'document',
  orderings: [
    {
      title: 'Order',
      name: 'orderAsc',
      by: [
        {field: 'order', direction: 'asc'},
        {field: 'name', direction: 'asc'},
      ],
    },
    {
      title: 'Name A-Z',
      name: 'nameAsc',
      by: [{field: 'name', direction: 'asc'}],
    },
  ],
  fields: [
    defineField({
      name: 'name',
      title: 'Name',
      type: 'string',
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      name: 'order',
      title: 'Order',
      type: 'number',
      description: 'Order in which tire types appear in buyer guides (lower numbers appear first)',
      validation: (Rule) => Rule.integer().min(0),
      initialValue: 0,
    }),
    defineField({
      name: 'performanceScore',
      title: 'Performance Score',
      type: 'number',
      description: 'Performance rating 1-10 (Winter=1, All-season=3, UHP Summer=5, Extreme Perf=7, R-compound=8, Slick=10)',
      validation: (Rule) => Rule.required().min(1).max(10),
      initialValue: 5,
    }),
  ],
})
